/*hack reason https://github.com/apollographql/apollo-feature-requests/issues/46
TODO remove once the mentioned feature is implemented*/

const ERROR_PREFIX = 'GraphQL error: ';
export const errorPrefixRemover = (errorMsg: string): string => errorMsg.replace(ERROR_PREFIX, '');
